import { useEffect } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { confirmLogout } from './adminAlerts';
import './AdminLayout.css';

const navItems = [
  {
    label: 'Main',
    items: [
      { to: '/admin/dashboard', label: 'Dashboard', icon: 'dashboard' },
    ],
  },
  {
    label: 'Content',
    items: [
      { to: '/admin/banner', label: 'Banner', icon: 'banner' },
      { to: '/admin/activity', label: 'Activity', icon: 'activity' },
      { to: '/admin/content', label: 'Content', icon: 'content' },
    ],
  },
];

function NavIcon({ name }) {
  if (name === 'dashboard') {
    return (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <rect x="2" y="2" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.4" />
        <rect x="10" y="2" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.4" />
        <rect x="2" y="10" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.4" />
        <rect x="10" y="10" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.4" />
      </svg>
    );
  }
  if (name === 'banner') {
    return (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <rect x="2" y="4" width="14" height="10" rx="1" stroke="currentColor" strokeWidth="1.4" />
        <path d="M2 8h14" stroke="currentColor" strokeWidth="1.4" />
      </svg>
    );
  }
  if (name === 'activity') {
    return (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <path d="M3 14V7l6-4 6 4v7" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      </svg>
    );
  }
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
      <rect x="3" y="3" width="12" height="12" rx="1" stroke="currentColor" strokeWidth="1.4" />
      <circle cx="7" cy="7" r="1.5" stroke="currentColor" strokeWidth="1.2" />
      <path d="M3 13l3-3 2 2 4-4 3 3" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  );
}

function AdminLayout() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const displayName = admin?.user?.name || admin?.email?.split('@')[0] || 'Admin';
  const initials = displayName.charAt(0).toUpperCase();

  useEffect(() => {
    document.title = 'Admin | inmotion';
  }, []);

  const handleLogout = async () => {
    const confirmed = await confirmLogout();
    if (!confirmed) return;

    logout();
    navigate('/admin');
  };

  return (
    <div className="admin-layout">
      <aside className="admin-layout__sidebar">
        <Link to="/admin/dashboard" className="admin-layout__brand">
          <span className="admin-layout__brand-icon" aria-hidden="true">in</span>
          <span className="admin-layout__brand-name">inmotion</span>
        </Link>

        <nav className="admin-layout__nav">
          {navItems.map((group) => (
            <div key={group.label} className="admin-layout__nav-group">
              <p className="admin-layout__nav-label">{group.label}</p>
              {group.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `admin-layout__nav-link${isActive ? ' admin-layout__nav-link--active' : ''}`
                  }
                >
                  <NavIcon name={item.icon} />
                  {item.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div className="admin-layout__sidebar-footer">
          <button type="button" className="admin-layout__logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </aside>

      <div className="admin-layout__body">
        <header className="admin-layout__topbar">
          <div className="admin-layout__topbar-actions">
            <Link to="/" className="admin-layout__topbar-btn">
              View site
            </Link>
          </div>
          <div className="admin-layout__profile">
            <span className="admin-layout__avatar">{initials}</span>
            <span className="admin-layout__greeting">Hello {displayName}</span>
          </div>
        </header>

        <main className="admin-layout__main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
